var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default"),(_vm.array && _vm.array.length !== 1)?[_vm._v("s")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }